import React from "react";
import BaseModal from "./BaseModal";
import LoadingIndicator from "../../meta/LoadingIndicator";

function ClearResponsesModal(props){
    const {clearResponses, showModal, closeModal, responsesAreBeingDeleted} = props;

    const okButton = (e) => {
        e.preventDefault();
        if (responsesAreBeingDeleted) return;
        clearResponses();
    };

    const cancelButton = (e) => {
        e.preventDefault();
        if (responsesAreBeingDeleted) return;
        closeModal();
    };

    return showModal ? (
        <BaseModal modalId={"myModal"} modalClass={"modal"}>
            <div className="modal-content">
                <span className="close" onClick={cancelButton}>&times;</span>
                <div className="modal-content__title modal-content__title--center">Are you sure you want to clear all responses to this survey?</div>
                <div className="modal-content__subtitle">All survey responses collected will be permanently deleted.</div>
                {responsesAreBeingDeleted && <div className="modal-content__subtitle"><LoadingIndicator/></div>}
                <div className="modal-content__actions modal-content__actions--center">
                    <a href="#"
                       className={"modal-content__actions__btn " + (responsesAreBeingDeleted ? " modal-content__actions__btn--disabled " : "")}
                       onClick={okButton}>Yes, clear all responses</a>
                    <a href="#"
                       className={"modal-content__actions__btn " + (responsesAreBeingDeleted ? " modal-content__actions__btn--disabled " : " modal-content__actions__btn--filledBlue ")}
                       onClick={cancelButton}>No, go back</a>
                </div>
            </div>
        </BaseModal>
    ) : null;
}

export default ClearResponsesModal;
